<sfx-header disableDividers>
    <div class="section-header" data-layout="row" data-layout-align="space-between center">
        <span translate>Email accounts</span>
        <button mat-button color="primary" track-id="connect-email" [matMenuTriggerFor]="connectEmailMenu">
            <span translate>Connect email</span>
        </button>
    </div>
</sfx-header>

<mat-menu #connectEmailMenu="matMenu" class="connect-account-menu" xPosition="before">
    <button mat-menu-item track-id="connect-google-email" (click)="connectGmail(true)">
        <mat-icon fontSet="salesflare" fontIcon="sf-icon-google"></mat-icon>
        <span>{{ 'Gmail' | translate }}</span>
    </button>
    <button mat-menu-item track-id="connect-office-email" (click)="connectOffice365()">
        <mat-icon fontSet="salesflare" fontIcon="sf-icon-office"></mat-icon>
        <span>{{ 'Office 365' | translate }}</span>
    </button>
    <button mat-menu-item track-id="connect-outlook-email" (click)="connectOffice365()">
        <mat-icon fontSet="salesflare" fontIcon="sf-icon-outlook"></mat-icon>
        <span>{{ 'Outlook.com' | translate }}</span>
    </button>
    <button mat-menu-item track-id="connect-other-email" (click)="connectOther()">
        <mat-icon fontSet="salesflare" fontIcon="sf-icon-email"></mat-icon>
        <span>{{ 'Other via IMAP' | translate }}</span>
    </button>
</mat-menu>

<sfx-section disableContentPadding>

    <p *ngIf="emailAccountsSubject$.value.emailAccounts.length === 0 && !loading" class="section-empty-text" translate>No email accounts connected yet!</p>

    <ng-container *ngFor="let emailAccount of emailAccountsToReconnect$ | async">

        <mat-card appearance="outlined">
            <mat-card-header>
                <img [src]="emailAccount.avatar" mat-card-avatar/>
                <mat-card-title>
                    {{ emailAccount.name }}
                    <span class="text-color font-weight_normal">{{ emailAccount.primary ? (' - ' + ('primary' | translate)) : ''}}</span>
                </mat-card-title>
                <mat-card-subtitle>{{ emailAccount.email }}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <p class="warning" translate>
                    The email infrastructure has been upgraded! Please reconnect.
                </p>
            </mat-card-content>
            <mat-card-actions>
                <button mat-button (click)="reconnect(emailAccount)" [disabled]="emailAccount.disconnecting" translate>Reconnect</button>
                <button mat-button track-id="disconnect-email" (click)="disconnect(emailAccount)" [disabled]="emailAccount.disconnecting" translate>Disconnect</button>
            </mat-card-actions>
        </mat-card>

    </ng-container>

    <ng-container *ngFor="let emailAccount of emailAccounts$ | async">

        <mat-card appearance="outlined">
            <mat-card-header>
                <img [src]="emailAccount.avatar" mat-card-avatar/>
                <mat-card-title>
                    {{ emailAccount.name }}
                    <span class="text-color font-weight_normal">{{ emailAccount.primary ? (' - ' + ('primary' | translate)) : ''}}</span>
                </mat-card-title>
                <mat-card-subtitle>{{ emailAccount.email }}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <p *ngIf="emailAccount.status === 'RECONNECT'" class="warning" translate>We've updated our Gmail integration to use more specific permissions. Please reconnect.</p>
                <p *ngIf="emailAccount.status === 'ERROR'" class="warning" translate>It looks like there is something wrong with your connection! Please reconnect.</p>
                <p *ngIf="emailAccount.status !== 'ERROR' && emailAccount.status !== 'RECONNECT'">{{ syncTextTranslations[emailAccount.sync_status] }}</p>
            </mat-card-content>
            <mat-card-actions>
                <button mat-button *ngIf="emailAccount.status === 'ERROR' || emailAccount.status === 'RECONNECT'" (click)="reconnect(emailAccount)" [disabled]="emailAccount.disconnecting"><span translate>Reconnect</span></button>
                <button mat-button *ngIf="!emailAccount.primary && emailAccount.status !== 'ERROR' && emailAccount.status !== 'RECONNECT' && modelService.me.team.payment_type !== 'samsung'" (click)="makePrimary(emailAccount)" [disabled]="emailAccount.disconnecting"><span translate>Make primary</span></button>
                <button mat-button *ngIf="emailAccount.type !== 'google' && emailAccount.type !== 'microsoft' && emailAccount.status !== 'ERROR' && emailAccount.status !== 'RECONNECT' && (emailAccount.smtp_host && emailAccount.smtp_host)" (click)="updateSMTPSettings(emailAccount)" [disabled]="emailAccount.disconnecting"><span translate>Edit SMTP settings</span></button>
                <button mat-button *ngIf="emailAccount.type !== 'google' && emailAccount.type !== 'microsoft' && emailAccount.status !== 'ERROR' && emailAccount.status !== 'RECONNECT' && (!emailAccount.smtp_host || !emailAccount.smtp_host)" (click)="updateSMTPSettings(emailAccount)" [disabled]="emailAccount.disconnecting"><span translate>Add SMTP settings</span></button>
                <button mat-button track-id="edit-signature" (click)="editSignature(emailAccount)" [disabled]="emailAccount.disconnecting"><span translate>Edit signature</span></button>
                <button mat-button track-id="set-quota" (click)="setQuota(emailAccount)" [disabled]="emailAccount.disconnecting"><span translate>Set quota</span></button>
                <button mat-button track-id="disconnect-email" (click)="disconnect(emailAccount)" [disabled]="emailAccount.disconnecting"><span translate>Disconnect</span></button>
            </mat-card-actions>
        </mat-card>

    </ng-container>

</sfx-section>
